<template>
  <transition name="slide-fade">
    <div>
      <div id="homeHeader" style="">
        <div class="container" >
          <header>
            <div class="row">
              <div class="col-md-8 mb-2 order-1 order-md-0">
                <h1 class="page-header">
                  <span v-if="user && user.guardian">Welcome to {{ user.firstName}}'s Account!</span>
                  <span v-else-if="user">Welcome {{ user.firstName }}!</span>
                </h1>
              </div>
              <div class="col-md-4 text-md-right text-left order-0 order-md-1">
                <img src="static/Microba-Logo-White.png" style="height:50px;">
              </div>
              <div class="col-12 order-2">
                <div class="page-description mb-4" >
                  This is the Microba Discovery Portal where you can keep track of your <i>Microba Insight<sup><small> TM</small></sup></sup></i> kit, view your interactive report when it is ready, answer questionnaires and access frequently asked questions. You can navigate to these different areas by clicking on the appropriate icon in the bar on the left. Enjoy your explorations!
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
      <div class="dashboard" v-if="dashboard && user">
        <div class="container" >
          <div class="row padded-row">
            <div class="col-md-4 col-12 mb-4">

              <div class="mb-3 btn-card-background">
                <router-link :to="'kits'" class="btn-card grey" href="#" @click.prevent="showOrderModal = true">
                  <div>
                    <i data-v-a48edea6="" class="icon-dashboard"></i>
                    View your sampling kits
                  </div>
                </router-link>
              </div>
              <div class="btn-card-background">
                <a @click.prevent="showRedeem" class="btn-card purple" href="">
                  <div>
                    <i data-v-a48edea6="" class="icon-dashboard"></i>
                    Enter a Voucher Code
                  </div>
                </a>
              </div>
            </div>
            <div class="col-12 col-md-8 mb-4">
              <div id="notifications" class="card">
                <div class="card-body row">
                  <div class="col-12">
                    <h4 v-show="getKits && getKits.length > 0" class="pb-2 dashboardSubtitle">Notifications</h4>
                    <template v-for="kit in getKitNotifications">
                      <div class="mb-2 row notificationRow">
                        <div class="col-12 col-lg-2 col-md-4">
                          <strong v-if="kit.name" class="limitText">{{ kit.name }}</strong>
                          <strong v-else>KIT-{{ kit.id }}</strong>
                        </div>
                        <div class="col-12 col-lg-8 col-md-6">
                          <span>{{ getStatusText(kit.sampleStatus || kit.kitStatus) }}</span>
                        </div>
                        <div class="col-12 col-lg-2 col-md-2 text-left text-md-right"><strong>

                          <router-link :to="getStatusLink(kit.sampleStatus || kit.kitStatus)">view</router-link>

                        </strong></div>
                      </div>
                    </template>
                    <template v-if="getKits && getKits.length < 1">
                      <div class="row">
                        <div class="col-12 text-center">
                          No notifications to display at present.
                        </div>
                      </div>
                    </template>


                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row padded-row">
            <div class="col-12 col-md-9 col-lg-6 mb-4">
              <WidgetAdd v-if="availableKits.length < 1"
                         title="<i>Understanding</i><br/>your microbiome"
                         image="none"
                         textAlign="RIGHT"
                         background="./static/Microbiome_coach_-_small.jpg"
                         body=""
                         callToAction="Microbiome Coach"
                         @onClick="showCoachInfoModal = true "/>



              <WidgetAdd v-else
                         title="<i>Understanding</i><br/>your microbiome"
                         image="none"
                         textAlign="RIGHT"
                         background="./static/MicrobiomeCoach-Dashboard.png"
                         body=""
                         callToAction="Microbiome Coach"
                         @onClick="showCoachInfoModal = true "/>
            </div>
            <div class="col-12 col-md-9 col-lg-6 mb-4">
              <WidgetAdd
                title="<i>Monitor</i>  your<br/>gut microbiome"
                image="none"
                textAlign="LEFT"
                background="./static/Add_to_my_Journey-small.jpg"
                body=""
                callToAction="Add a kit to your journey"
                @onClick="showPurchaseModal = true" />
            </div>
          </div>

          <div class="row padded-row">
            <div class="col-12 mb-4">
              <div class="card">
                <div class="card-body row">
                  <div class="col-12">
                    <h4 v-show="getKits && getKits.length > 0" class="pb-2 dashboardSubtitle">Summary</h4>


                    <div class="row" v-if="getKits">
                      <div class="col-md-3 col-12  mb-3 mb-md-0">
                        <div class="card  card-kit">
                          <div class="card-body">
                            <div class="title">{{ activatedKits.length }} <div class="titleInner">/{{ getKits.length }}</div></div>
                            <div class="status">Activated kits</div>
                            <router-link :to="{ name: 'Your kits' }" href="#">View My Kits</router-link>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12  mb-3 mb-md-0">
                        <div class="card  card-kit">
                          <div class="card-body">
                            <div class="title">{{ availableKits.length }} <div class="titleInner">/{{ getKits.length }}</div></div>
                            <div class="status">Reports received</div>
                            <router-link :to="{ name: 'Reports' }">Learn more</router-link>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12  mb-3 mb-md-0">
                        <div class="card  card-kit">
                          <div class="card-body">
                            <div class="title">{{ coachKits.length }} <div class="titleInner">/{{ getKits.length }}</div></div>
                            <div class="status">Coach sessions</div>
                            <router-link :to="{ name: 'Coach' }">Learn more</router-link>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12  mb-3 mb-md-0">
                        <div class="card  card-kit">
                          <div class="card-body">
                            <div class="title">- <div class="titleInner">/{{ getKits.length }}</div></div>
                            <div class="status">Reports compared</div>
                            <router-link :to="{ name: 'Journey' }">Learn more</router-link>
                          </div>
                        </div>
                      </div>
                    </div>


                    <template v-if="getKitNotifications && getKitNotifications.length < 1">
                      <div class="row">
                        <div class="col-12 text-center">
                          No kits to display at present.
                        </div>
                      </div>
                    </template>


                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <ModalCoachInfo :show="showCoachInfoModal" @close="showCoachInfoModal = false" />

        <ModalRedeemAKit :kitID="selectedKit" :slide="activatePage" :show="showRedeemModal" @close="showRedeemModal = false" />

        <ModalOrder
          :show="showPurchaseModal"
          :product="additionalKit"
          :showIntro="true"
          heading=""
          title="Confirm your details"
          copy="Please confirm your details below"
          @close="showPurchaseModal = false"
        />



      </div>
    </div>
  </transition>
</template>

<script>
  import ModalOrder from '@/components/models/ModalOrder'
  import ModalRedeemAKit from '@/components/models/ModalRedeemAKit'
  import ModalCoachInfo from '@/components/models/ModalCoachInfo'
  import WidgetAction from '@/components/widgets/WidgetAction'
  import WidgetAdd from '@/components/widgets/WidgetAdd'
  import WidgetMyKits from '@/components/widgets/widget-my-kits'
  import UserMixins from '@/mixins/userProfile'
  import {kitStatuses} from '@/enums/kitItemStatus'
  import _ from 'lodash'

  export default {
    name: 'Dashboard',
    components: {
      WidgetAdd,
      WidgetAction,
      WidgetMyKits,
      ModalOrder,
      ModalRedeemAKit,
      ModalCoachInfo
    },
    mixins: [ UserMixins ],
    mounted: function () {
      let self = this
      this.$store.dispatch('getUser').then(success => {
        let redeemObj = localStorage.getItem('redeem_on_register')
        if (redeemObj) {
          localStorage.removeItem('redeem_on_register')
          self.joinProject(JSON.parse(redeemObj))
        }
      })
      this.$store.dispatch('getDashboard')
      this.$store.dispatch('getUserKits')
      // this.$store.dispatch('getResearchKits').then(success => {
      //   self.checkUnassignedKit()
      // })

      // if (this.$route.query.showModal && this.$route.query.showModal === 'REDEEM') {
      //   this.showRedeemModal = true
      // }
    },
    data: function () {
      return {
        showAddProjectModal: false,
        showRedeemKitModal: false,
        showActivateModal: false,
        showPurchaseModal: false,
        showRedeemModal: false,
        showCoachInfoModal: false,
        activatePage: '',
        selectedKit: '',
        selectedProject: '',
        additionalKit: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        },
        statusText: {
          REQUESTED: 'Preparing your order',
          DISPATCHED: 'Your kit has been dispatched',
          RECEIVED_BY_LAB: 'Sample received by lab',
          ACCESSIONING: 'Lab is processing your sample',
          RESULTS_AVAILABLE: 'Your report is available',
          MICROBIOME_COACH_SESSION_COMPLETED: 'Book a Microbiome Coach session'
        },
        statusLinks: {
          REQUESTED: { name: 'Your kits' },
          DISPATCHED: { name: 'Your kits' },
          RECEIVED_BY_LAB: { name: 'Your kits' },
          RESULTS_AVAILABLE: { name: 'Reports' },
          MICROBIOME_COACH_SESSION_COMPLETED: { name: 'Your kits' }
        }
      }
    },
    computed: {
      getKitNotifications () {
        const kits = this.getKits ? this.getKits : []
        return _.take(kits.filter(kit => kit.kitStatus !== kitStatuses.INVALIDATED), 4)
      },
      availableKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.sampleStatus === 'RESULTS_AVAILABLE' || thisKit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      activatedKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.kitStatus !== 'UNASSIGNED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      coachKits: function () {
        const myKits = []
        for (var kitId in this.getKits) {
          let thisKit = this.getKits[kitId]
          if (thisKit.sampleStatus === 'MICROBIOME_COACH_SESSION_COMPLETED') {
            myKits.push(thisKit)
          }
        }
        return myKits
      },
      dashboard: function () {
        return this.$store.state.GET_DASHBOARD_RESPONSE || {}
      },
      totalKits: function () {
        if (!this.dashboard) return 0
        return this.dashboard.numberOfUnassignedKits + this.dashboard.numberOfRedeemedKits
      },
      unasignedKits: function () {
        if (!this.dashboard) return 0
        return this.dashboard.numberOfUnassignedKits
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      getKits: function () {
        return this.$store.state.GET_KITS_RESPONSE
      },
      enableSurveys: function () {
        // return true
        return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
      }
    },
    methods: {
      getStatusText (status) {
        if (this.statusText[status]) {
          return this.statusText[status]
        }
        return 'Kit Purchased'
      },
      getStatusLink (status) {
        if (this.statusText[status]) {
          return this.statusLinks[status]
        }
        return { name: 'Your kits' }
      },
      showRedeem () {
        this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
        this.showRedeemModal = true
      },
      hasQuestionnaries (project, kit) {
        return project.exerciseSurveyEnabled || project.foodSurveyEnabled || project.medicalSurveyEnabled || project.mentalSurveyEnabled || project.samplingSurveyEnabled
      },
      checkUnassignedKit () {
        let self = this

        if (!self.getKits) return

        if (!self.showRedeemModal) return
        for (let proj = 0; proj <= self.getKits.length; proj++) {
          for (let kit = 0; kit <= self.getKits[proj]['kits'].length; kit++) {
            if (self.getKits[proj]['kits'][kit]['kitStatus'] === 'ASSIGNED') {
              self.onClickActivate(self.getKits[proj]['kits'][kit]['id'])
              return
            }
          }
        }
      },
      onClickActivate: function (kitID) {
        console.log(kitID)
        this.selectedKit = kitID
        this.showActivateModal = true
      },
      addProject () {
        this.showAddProjectModal = true
      },
      redeemCode () {
        this.showRedeemKitModal = true
      },
      joinProject (obj) {
        const payload = {
          'participantIdentifier': obj.participantIdentifier,
          'userId': this.user.id
        }
        let self = this

        this.$store.dispatch('joinResearch', payload).then(success => {
          console.log('Project', success)
          self.redeemVoucher(obj)
        }).catch(error => {
          console.log('ERROR', error)
        })
      },
      redeemVoucher (obj) {
        let self = this
        const payload = {
          voucher: obj.voucherCode
        }
        this.$store.dispatch('checkVoucher', payload).then(success => {
          // self.selectedKit = success.data
          console.log('KIT', success.data)
          self.processRedeem(success.data, obj)
        }).catch(error => {
          console.log('ERROR', error)
          self.error = 'You have entered an invalid voucher code. Please check the code or contact your project administrator.'
        })
      },
      processRedeem (kit, obj) {
        const payload = {
          kitId: kit.id,
          addressLine1: '',
          addressLine2: '',
          suburb: '',
          state: '',
          postcode: '',
          voucher: obj.voucherCode,
          activate: false
        }
        let self = this

        this.$store.dispatch('redeemKitBasic', payload).then(success => {
          self.$store.dispatch('getResearchKits')
          self.checkUnassignedKit()
        }).catch(error => {
          console.log('ERROR', error)
        })
      }
    },
    watch: {
      dashboard: function (dash) {
        // Redirect to profule if not complete
        if (this.dashboard.profileCompleted === false) {
          this.$bus.$emit('disableSidebar')
          this.$router.push('/profile')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



  .chart-wrap {
    position: relative;
    height: 200px;
    margin: 50px auto;
  }

  em {
    font-size: 17px;
    opacity: 0.7;
    max-width: 500px;
    margin: 0px auto;
  }
  .padded-row {
    padding-bottom:0;
    @media (min-width:992px) {
      padding-bottom:1rem;
    }
  }

  .mb-4 {
    margin-bottom: 1.25rem !important;
    @media (min-width:992px) {
      margin-bottom: 1.5rem !important;
    }
  }



  .dashboard {
    //padding-bottom:2.5rem;
    padding-bottom:100px;
  }

  #homeHeader{
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#8873b6+0,5396ca+100 */
    background: #8873b6; /* Old browsers */
    background: -moz-linear-gradient(left, #8873b6 0%, #5396ca 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #8873b6 0%,#5396ca 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #8873b6 0%,#5396ca 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    background: url('~@/assets/images/bg-dashboard-img.jpg') no-repeat;
    background-size: cover;
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8873b6', endColorstr='#5396ca',GradientType=1 ); /* IE6-9 */

    padding:4rem 0;
    margin-bottom:2rem;

  }
  #homeHeader span{
    color:#fff;
  }
  #homeHeader .page-description{
    color:#fff
  }

  .btn-outline-secondary{
    border-color:#fff;
    color:#fff;
  }
  .btn-outline-secondary:hover{
    background-color:#fff;
    color:#000;
  }
  .buy-buttons .list-group-item{
    background: #eee;
  }


  .notificationRow{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
    background:#eee;
    padding:15px;
  }

  .dashboard{
    margin-top:-100px;
  }

  .dashboardSubtitle{
    height: 21px;
    width: 231px;
    color: #00193D;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
  }

  .card-kit {
    height: 180px;
    border-radius: 4px;
    background-color: #F4F4F4;
    border: 0px;

    .title{
      font-size: 42px;
      font-weight: 300;
      line-height: 22px;
      text-align: center;
      margin-top:25px;
      margin-bottom:30px;
      margin-left:20px;
      width:100%;
    }
    .titleInner{
      display:inline-block;
      color: #818A97;
      font-size: 22px;
      font-weight: 300;
      line-height: 22px;
      margin-left:20px;
      text-align:right;
      margin-top:10px;
    }

    .status{
      color: #00193D;
      font-size: 16px;
      font-weight: 300;
      line-height: 22px;
      text-align: center;
    }

    a{
      margin-top:10px;
      display:block;
      font-size: 16px;
      font-style: italic;
      font-weight: 500;
      line-height: 22px;
      text-align: center;
    }
  }

  #notifications{
    .card-body{
      min-height:305px;
    }
  }

  .limitText {
    display: block;
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .btn-card i {
    font-size:28px;
  }
</style>



// WEBPACK FOOTER //
// src/application/customer/Dashboard.vue